class SortableEls {
    constructor(elements, input) {
        this.sorts = ['', 'desc', 'asc'];
        this.listener = () => {};
        this.elements = elements;
        this.input = input;

        this.elements.forEach((el) => {
            el.addEventListener('click', this.handleClick.bind(this, el));
        })
    }

    handleClick(el) {
        this.removeSort(el);
        const val = this.getNextSort(el.dataset.sort);
        this.setSort(el, val);
        this.input.name = `sort[${el.dataset.name}]`;
        this.input.value = val;
        this.listener();
    }

    getNextSort(name) {
        const next = this.sorts.indexOf(name) + 1;
        if(this.sorts.length > next) {
            return this.sorts[next];
        }
        else {
            return this.sorts[0];
        }
    }


    removeSort(except) {
        this.elements.forEach((el) => {
            if(el !== except) {
                this.setSort(el);
            }
        })
    }

    setSort(el, val = '') {
        el.dataset.sort = val;
        el.setAttribute('data-sort', val);
    }
}

document.querySelectorAll('.ApartmentsListFilter').forEach((el) => {
    const formEl = el.querySelector('form');
    const inputs = formEl.querySelectorAll('input');
    let slider = el.querySelector('.RangeDouble__range');
    if(slider) {
        slider = slider.noUiSlider;
    }
    const inputSort = el.querySelector('.ApartmentsListTable__input-sort');
    const sortableEls = el.querySelectorAll('.ApartmentsListTable__title>div[data-sort]');
    const sort = new SortableEls(sortableEls, inputSort);
    let page = 1;

    let table = el.querySelector('.ApartmentsListTable');
    let tableList = el.querySelector('.ApartmentsListTable__list');
    setHandle();

    const getList = debounce(() => {
        page = 1;
        setHtmlAnimation(formEl.action);
    }, 1000);
    sort.listener = getList.force;

    inputs.forEach((input) => {
        input.addEventListener('input', () => {
            getList();
        });
    });
    if(slider){
        slider.on('set',  () => {
            getList();
        });
    }

    function setHtml(html, append = false) {
        const btn = table.querySelector('button');
        if (btn) {
            btn.remove();
        }
        if (append) {
            tableList.innerHTML += html;
        } else {
            tableList.innerHTML = html;
        }
        setHandle();
    }

    function loadNextPage(_page = page + 1) {
        page = _page;
        return fetch(formEl.action+getData()).then((d) => d.text()).then((html) => {
            setHtml(html, true);
            setTimeout(() => toggleClass(false), 100);
        })
    }

    function setHandle() {
        const btn = table.querySelector('button');
        if (btn) {
            btn.addEventListener('click', () => {
                loadNextPage(btn.dataset.page || undefined);
            })
        }
    }

    function setHtmlAnimation(url) {
        return animation(() => {
            return fetch(url+getData()).then((r) => r.text());
        });
    }

    async function animation(getData) {
        toggleClass(true);
        await new Promise(r => setTimeout(r, 300));
        setHtml(await getData());
        await new Promise(r => setTimeout(r, 100));
        toggleClass(false);
    }

    function toggleClass(state) {
        Array.from(tableList.children).forEach((el) => {
            if(el.tagName !== 'BUTTON') {
                el.classList.toggle('ApartmentsListTable__item--hide', state);
            }
        })
    }

    function getData() {
        const form = new FormData(formEl);
        form.append('page', page)
        form.append(inputSort.name, inputSort.value)
        const data = new URLSearchParams(form);
        return `?${data.toString()}`;
    }
})
